/**
 * Formatea un número como moneda en Soles peruanos
 * @param {number} amount - El monto a formatear
 * @returns {string} - El monto formateado con el símbolo S/
 */
export const formatCurrency = (amount) => {
  // Manejar valores no numéricos
  const numAmount = typeof amount === 'number' ? amount : parseFloat(amount) || 0;
  return `S/ ${numAmount.toFixed(2)}`;
};

/**
 * Solo retorna el símbolo de moneda
 * @returns {string} - El símbolo de moneda
 */
export const getCurrencySymbol = () => {
  return 'S/';
};
